import { useContext } from 'react';
import { elementFieldPathHookContext } from './context';

export const useExecuteElementFieldPathHook = () => {
  const useElementFieldPathHook = useContext(elementFieldPathHookContext);
  const result = useElementFieldPathHook();
  return result;
};
